import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SpinachPaneerPulao() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Spinach Paneer Pulao</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 tbsp oil<br></br>
        220g pack paneer, cut into 1.5cm slices<br></br>1 onion, thinly sliced
        <br></br>2 garlic cloves, crushed<br></br>
        Thumb-size piece ginger, grated<br></br>1 tsp cumin seeds<br></br>1 tsp
        turmeric<br></br>1 tsp garam masala<br></br>1 tsp chilli flakes<br></br>
        2 large tomatoes, chopped<br></br>
        250g spinach<br></br>
        250g basmati rice<br></br>
        600ml vegetable stock<br></br>1 tbsp chopped coriander<br></br>
        Yogurt and mango chutney to serve<br></br>
      </Typography>

      <Typography>
        Heat the oil in a large, lidded, non-stick frying pan or shallow
        casserole over a medium heat.<br></br>
        Add the paneer and fry for 2-3 minutes until a deep golden brown. Set
        aside.<br></br>
        Add the onion and a pinch of salt and fry for 5 minutes.<br></br>
        Add the garlic, ginger, cumin, turmeric, garam masala and chilli flakes,
        then cook for 1 minute.<br></br>
        Stir in the tomatoes and spinach, then cook for 5 minutes.<br></br>
        <br></br>
        Rinse the rice in a sieve in cold water, changing the water 2-3 times.
        <br></br>
        Add the rice to the pan, stir well, then pour in the stock.<br></br>
        Cover with a lid and cook over a low-medium heat for 20 minutes or until
        the rice is cooked.<br></br>
        Top with the paneer, sprinkle with coriander and serve with yogurt and
        mango chutney.<br></br>
      </Typography>
    </Card>
  );
}
